/**
 * Tier model (ROLE-DESIGN-2026-07-11): ADMIN ⊃ WRITING agent ⊃ REFERRAL agent.
 *
 * The tier lives on the EXISTING `Agent.authority` field (spec Part 2
 * "Implementation mapping"): value "writing" marks a writing agent; every
 * other value — including the legacy default "agent", which all un-migrated
 * records still carry — is the default REFERRAL tier. Admin resolves via
 * attachRole admin-first and is a superset, so it needs no agent record.
 *
 * Everything here is UX-ONLY gating. The backend (attachRole/requireRole,
 * scoped lists, POLICY_LOCKED, and Session H's requireTier + referral policy
 * projection) is the real access boundary — hiding a tab never protects
 * data, it only keeps the UI honest about what the tier is for.
 */

export function tierFor(role, identity) {
  if (role === "admin") {
    return "admin";
  }
  if (role === "agent") {
    return identity && identity.authority === "writing" ? "writing" : "referral";
  }
  return null;
}

const STAFF = ["writing", "admin"];

/** Capability map per the spec's Part-8 permission matrix. */
export function tierCan(tier) {
  const staff = STAFF.includes(tier);
  return {
    // D2: referral agents see line/carrier/status/dates/premium + own split.
    seePolicyCoverages: staff,
    seeDocuments: staff, // referral own-uploads arrive with Phase 2.5 intake
    seeOtherSplits: staff,
    seeInternalNotes: staff,
    seeAgentAttribution: staff, // Book's Agent column / filter
    editRecords: staff, // W2 — client + policy edit (commission fields stay admin-locked server-side)
    isStaff: staff
  };
}

export const TIER_LABELS = {
  admin: "Admin",
  writing: "Writing agent",
  referral: "Referral agent"
};
